import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ReportSelect from "./ReportSelect";
import EventSpammerRepeatOffenders from "./EventSpammerRepeatOffenders";
import ShuttieStatus from "./ShuttieStatus";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

function EventSpammersReport(props) {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <AppBar position="static" style={{ background: "#2E3B55" }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="secondary"
        >
          <Tab label="Latest Report" />
          <Tab label="Repeat Offenders" />
          <Tab label="Shuttie Status" />
        </Tabs>
      </AppBar>

      <TabPanel value={tabValue} index={0}>
        <ReportSelect type={"event-spammers-report"} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <EventSpammerRepeatOffenders />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        {/* Only mount when opened: the cleaning-status query takes a few seconds */}
        {tabValue === 2 && <ShuttieStatus />}
      </TabPanel>
    </>
  );
}

export default EventSpammersReport;
